import request from 'assets/js/http';

// 邮件邀请
export function sendCodeEmail(userIds) {
  return request({
    url: '/account/sendCodeEmail',
    method: 'post',
    data: { userIds }
  });
}
export function userList(data) {
  // 获取用户列表
  return request({
    url: '/account/list',
    method: 'post',
    data
  });
}
export function addUser(data) {
  // 添加用户
  return request({
    url: '/account/add',
    method: 'post',
    data
  });
}
export function editUser(data) {
  // 修改用户
  return request({
    url: '/account/edit',
    method: 'post',
    data
  });
}
export function authUser(data) {
  // 用户授权
  return request({
    url: '/account/auth',
    method: 'post',
    data
  });
}
export function operateUser(data) {
  // 删除，冻结， 启用
  return request({
    url: '/account/operate',
    method: 'post',
    data
  });
}
export function uploadAvatar(data) {
  // 头像上传
  return request({
    url: '/upload/uploadAvatar',
    processData: false,
    headers: { 'content-type': 'multipart/form-data' },
    method: 'post',
    data
  });
}

export function editSelf(data) {
  return request({
    url: '/account/editSelf',
    method: 'post',
    data
  });
}
